module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.dataReady) ? _c('div', {
    staticClass: "container page-container"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24
    }
  }, [_c('h1', {
    on: {
      "click": function($event) {
        _vm.deleteFormVisible = true
      }
    }
  }, [_vm._v(_vm._s(_vm.user.email))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-checkbox', {
    on: {
      "change": _vm.updateUserRole
    },
    model: {
      value: (_vm.user.isAdmin),
      callback: function($$v) {
        _vm.user.isAdmin = $$v
      },
      expression: "user.isAdmin"
    }
  }, [_vm._v(" Admin")]), _c('br'), _vm._v(" "), (_vm.user.isAdmin !== true) ? _c('div', {
    staticClass: "project-select"
  }, [_c('h3', [_vm._v("Projects")]), _vm._v(" "), (_vm.projects) ? _c('ul', _vm._l((_vm.projects), function(project, index) {
    return _c('li', [_c('el-checkbox', {
      on: {
        "change": function($event) {
          _vm.updateUserProjects(project, _vm.user['.key'])
        }
      },
      model: {
        value: (project.users[_vm.user['.key']]),
        callback: function($$v) {
          var $$exp = project.users,
            $$idx = _vm.user['.key'];
          if (!Array.isArray($$exp)) {
            project.users[_vm.user['.key']] = $$v
          } else {
            $$exp.splice($$idx, 1, $$v)
          }
        },
        expression: "project.users[user['.key']]"
      }
    }, [_vm._v(" " + _vm._s(project.name))])], 1)
  })) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "large",
      "icon": "arrow-left"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$router.push('/users')
      }
    }
  }, [_vm._v(" Back to Users")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Are You Sure You Want To Delete This User?",
      "visible": _vm.deleteFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.deleteFormVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "label-position": _vm.labelPosition
    }
  }, [_c('p', [_vm._v("You will also need to delete the user in the "), _c('a', {
    staticClass: "link-out",
    attrs: {
      "href": "http://console.firebase.google.com",
      "target": "_blank"
    }
  }, [_vm._v("Firebase console")]), _vm._v(".")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.deleteFormVisible = false
      }
    }
  }, [_vm._v("No Way, Get Me Out Of Here!")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.deleteUser()
      }
    }
  }, [_vm._v("Delete")])], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7c92c98b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User.vue
// module id = 334
// module chunks = 2